import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { PageHeader, Spinner } from "@/components/common";
import { ProductCard } from "@/components/ProductCard";
import { useMeta } from "@/hooks/useMeta";
import { countdownText, liveHolidays } from "@/lib/heroRotation";

export default function GiftGuide() {
  const { site } = useSite() as any;
  const [d, setD] = useState<any>(null);
  useEffect(() => { api.get("/gift-guide").then((r) => setD(r.data)).catch(() => setD({ bands: [] })); }, []);
  const hol = useMemo(() => liveHolidays(site?.announcements?.holidays)[0], [site]);
  const title = d ? (hol?.name ? `${hol.name} Gift Guide` : d.title) : "";
  const cd = countdownText(hol);
  const [top, setTop] = useState(0);
  useEffect(() => { const h = document.querySelector("[data-testid=site-header]"); const f = () => setTop(h && getComputedStyle(h).position === "sticky" ? h.getBoundingClientRect().height : 0); f(); window.addEventListener("resize", f); return () => window.removeEventListener("resize", f); }, [d]);
  useMeta(title ? `${title} | Somnio.Co` : undefined, d?.intro);
  if (!d) return <Spinner />;
  return (
    <div data-testid="gift-guide-page">
      <PageHeader eyebrow="Gifts by budget" title={title} intro={d.intro} />
      {cd && <p className="max-w-[1400px] mx-auto px-5 md:px-12 -mt-4 mb-8 text-base font-medium text-neutral-900 tracking-wide" data-testid="gift-guide-countdown">{cd}</p>}
      <nav style={{ top }} className="sticky z-10 bg-[var(--c-bg)]/90 backdrop-blur border-y border-neutral-200 mb-12" data-testid="gift-guide-bands-nav">
        <div className="max-w-[1400px] mx-auto px-5 md:px-12 flex gap-2 overflow-x-auto py-3 [scrollbar-width:none]">
          {d.bands.map((b: any) => <a key={b.key} href={`#${b.key}`} className="shrink-0 border border-neutral-300 hover:border-neutral-900 px-4 py-2 text-xs tracking-wider uppercase transition-colors" data-testid={`gift-guide-band-link-${b.key}`}>{b.label}</a>)}
        </div>
      </nav>
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 space-y-20 pb-20">
        {d.bands.map((b: any) => (
          <section key={b.key} id={b.key} className="scroll-mt-40" data-testid={`gift-guide-band-${b.key}`}>
            <h2 className="font-display text-3xl md:text-4xl font-light mb-8">{b.label}</h2>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">{b.products.map((p: any, i: number) => <ProductCard key={p.id} p={p} index={i} />)}</div>
          </section>
        ))}
        {!d.bands.length && <p className="text-neutral-500" data-testid="gift-guide-empty">New gift picks are on their way.</p>}
        <div className="text-center border-t border-neutral-200 pt-14">
          <p className="font-display text-2xl font-light">Looking for something truly one of a kind?</p>
          <Link to="/consultation" className="btn-ink inline-block mt-6 px-9 py-4 text-xs tracking-[0.25em] uppercase" data-testid="gift-guide-consult">Book a Consultation</Link>
        </div>
      </div>
    </div>
  );
}
